import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

// const Usuario = ({styles, elemento}) => {
//   return(
//     <p>{elemento.email} {elemento.nombreUsuario}</p>
//   )};

// const DescrPerfil = props => <p>{props.elemento.descrPerfil}</p>;
 
// const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
//   return (
//     <div className="ui middle aligned animated celled link list" style={styles.styTableSup}>
//       <div className="item">
//         <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
//             <div className="right floated content" style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>
//                 <div><DescrPerfil elemento={elemento.perfil} /></div>
//             </div>
//             <img className="left floated ui avatar image" src="images/hombre.png" alt="imagen"></img>
//             <List.Header>
//                 <div className="floated content" style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>
//                     <a className="header"><Usuario elemento={elemento}/></a>
//                 </div>
//             </List.Header>
//         </List.Item>
//       </div>
//     </div>
//   )
// };
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  let urlSlcm = 'https://montserratslcm.com/api/logos/'
  return (
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.email}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuario}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cedula}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.perfil.descrPerfil}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.esLider?elemento.esLider:'No'}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.suLider?elemento.suLider:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cargo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ciudad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.telefono}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.gestionaHallazgos}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em'}}>
        {elemento.archivoFirma &&
           <img src={urlSlcm + elemento.archivoFirma} height = {70} width = {100} alt="Imagen"/>
          }
        {!elemento.archivoFirma &&
          ""
        }
      </td>
    </tr>  
  )
};
const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 handleClickidLista={handleClickidLista} 
   elemento={elemento}
   key={elemento._id} />);
  return(
    <tbody className=''>
    {nivel1Detalle}
  </tbody>
  )
};

const UserUsu2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a201001 = autorizacUA.findIndex( autorizac => autorizac === "201001" );
  console.log(list)

  return (
    // <div>
    //   <List selection>
    //   <TitDer list={list} textBoton1="Usuarios" btnNuevo={a201001!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />

    //   <Lista list={list} styles={styles} handleClickidLista={handleClickidLista}/>
    //   </List>
    // </div>
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Usuarios" btnNuevo={a201001!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>tipo</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Usuario</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Nombre</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Cédula</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Perfil</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Es lider ?</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Su lider es:</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Estado</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Cargo</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Ciudad</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Teléfono</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Gestiona hallazgos</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Archivo de firma</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
      </List>
    </div>
  )
};

export default UserUsu2